import { all, fork } from 'redux-saga/effects';

import { watchApp } from './modules/app/effects';
import { watchOutcodes } from './modules/outcodes/effects';
import { watchAreas } from './modules/areas/effects';
import { watchStaff } from './modules/staff/effects';
import { watchQueued } from './modules/queued/effects';
import { watchJobs } from './modules/jobs/effects';
import { watchJourneys } from './modules/journeys/effects';
import { watchJourneyStops } from './modules/journey-stops/effects';
import { watchJourneyEdit } from './modules/journey-edit/effects';
import { watchJourneyHandling } from './modules/journey-handling/effects';
import { watchJourneyMap } from './modules/journey-map/effects';
import { watchShipperOrders } from './modules/shipper-orders/effects';
import { watchFinishedJourneys } from './modules/finished-journeys/effects';
import { watchCommon } from './modules/common/effects';
import { watchJobDetail } from './modules/job-detail/effects';
import { watchLog } from './modules/log/effects';
import { watchAlerts } from './modules/alerts/effects';
import { watchShipperOrderDetail } from './modules/shipper-order-detail/effects';
import { watchShipperOrderForm } from './modules/shipper-order-form/effects';
import { watchShipperOrderNew } from './modules/shipper-order-new/effects';
import { watchShipperOrderEdit } from './modules/shipper-order-edit/effects';
import { watchShipperOrderDocuments } from './modules/shipper-order-documents/effects';
import { watchHandleErrors } from './modules/error-handler/effects';

import { watchNavigation } from './modules/navigation/effects';
import { watchRecurringOrders } from './modules/recurring-orders/effects';
import { watchRecurringOrdersEdit } from './modules/recurring-orders-edit/effects';

import { watchAnalytics } from './modules/analytics/effects';

import { watchCarrierSection } from './modules/carrier-section/effects';
import { watchVehicleSection } from './modules/vehicle-section/effects';
import { watchJourneyHistoricalRoutes } from './modules/journey-historical-routes/effects';

import { watchDriverJourneys } from 'modules/driver-journeys/redux/effects';

export default function* rootSaga() {
  yield all([
    fork(watchApp),
    fork(watchOutcodes),
    fork(watchAreas),
    fork(watchStaff),
    fork(watchQueued),
    fork(watchJobs),
    fork(watchJourneys),
    fork(watchJourneyStops),
    fork(watchJourneyEdit),
    fork(watchJourneyHandling),
    fork(watchJourneyMap),
    fork(watchShipperOrders),
    fork(watchFinishedJourneys),
    fork(watchCommon),
    fork(watchJobDetail),
    fork(watchLog),
    fork(watchAlerts),
    fork(watchShipperOrderDetail),
    fork(watchShipperOrderForm),
    fork(watchShipperOrderNew),
    fork(watchShipperOrderEdit),
    fork(watchShipperOrderDocuments),
    fork(watchRecurringOrders),
    fork(watchRecurringOrdersEdit),
    fork(watchNavigation),
    fork(watchAnalytics),
    fork(watchHandleErrors),
    fork(watchCarrierSection),
    fork(watchVehicleSection),
    fork(watchDriverJourneys),
    fork(watchJourneyHistoricalRoutes),
  ]);
}
